<!--
Directions > building from screen
@author bmk11u, crm4f
-->
<template>
  <div>
    <Nav name="Directions from Building" v-bind:home="true" v-if="authenticated" />
    <Nav name="Directions from Building" v-if="!authenticated" />
    <SearchList name="building" id="buildingId" label="buildingName" data="/map/buildings"
      :href="'directions?toId=' + toId + '&toType=' + toType + '&fromId={buildingId}&fromType=B'" :exclude="buildingId" />
    <div id="pusher"></div>
    <Footer active="notifications" v-if="authenticated"/>
  </div>
</template>

<script setup>
import SearchList from '@/components/SearchList.vue'
import { useLocationsCommon } from '@/composables/LocationsCommon.js'
import Footer from '@/components/FooterMenu.vue'
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

const buildingId = ref(null)
const toId = ref(null)
const toType = ref(null)

const { authenticated } = useLocationsCommon()

const route = useRoute()

onMounted(() => {
  console.log('authenticated:', authenticated.value)
  buildingId.value = route.query.buildingId
  toId.value = route.query.toId
  toType.value = route.query.toType
})

</script>
